import React from 'react';
import { List, Datagrid, TextField, EditButton, DeleteButton, SavedQueriesList, FilterLiveSearch } from 'react-admin';
import { Card, CardContent } from '@mui/material';
import StandardListActions from './StandardListActions';

export const PermissionsFilterSidebar = () => (
    <Card sx={{ order: -1, mr: 2, mt: 6, width: 'max-content' }}>
        <CardContent>
            <SavedQueriesList />

            <FilterLiveSearch label='Name' source='name__ilike' variant='outlined' />
        </CardContent>
    </Card>
);

const PermissionsList = (props: any) => {
    return (
        <List {...props} aside={<PermissionsFilterSidebar />} actions={<StandardListActions />}>
            <Datagrid rowClick='edit'>
                <TextField source='id' />
                <TextField source='name' />
                <EditButton />
                <DeleteButton />
            </Datagrid>
        </List>
    );
};

export default PermissionsList;
